var getIconName = function (iconName) {
    return (iconName && iconName.indexOf('k-i-') !== -1)
        ? iconName.split('k-i-')[1]
        : iconName;
};
export { getIconName };
